import ThermostatSectionRoot, {
  Props as ComponentProps,
} from './ThermostatSection'
import useViewModel from './useViewModel'
import { ViewModelComponentProps } from '../../../../../../utils/typeUtilities'
import { ID } from '@/types/model'
import ErrorBoundary, {
  LocationTag,
} from '@/authenticated/components/ErrorBoundary'
import ThermostatDREventAlertAndDetails from '@/app/features/smart-thermostats/ThermostatDREventAlertAndDetails'
import UtilityProgramDashboardAlert from '@/app/features/utility-programs/UtilityProgramDashboardAlert'
import UtilityProgramLearnMoreDashboardView from '@/app/features/utility-programs/UtilityProgramLearnMoreDashboardView'

export type Props = ViewModelComponentProps<ComponentProps, typeof useViewModel>

export default function ThermostatSection(props: Props) {
  const viewModel = useViewModel(props)

  return <ThermostatSectionRoot {...viewModel} />
}

export function ThermostatSectionHeader({
  thermostatId,
}: {
  thermostatId: ID
}) {
  return (
    <>
      <UtilityProgramLearnMoreDashboardView />
      <ErrorBoundary
        location={LocationTag.Dashboard}
        functionalityDescription={
          'Thermostat Demand Response Event Alert and Details'
        }
        severity="critical"
        fallbackOnCard
      >
        <ThermostatDREventAlertAndDetails thermostatId={thermostatId} />
        <UtilityProgramDashboardAlert
          deviceId={thermostatId}
          deviceType="thermostat"
        />
      </ErrorBoundary>
    </>
  )
}
